import { AlertTriangle } from "lucide-react"
import { useNavigate } from "react-router-dom"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { useLeftActivityAlertStore } from "../store/use-left-activity-alert"
import { useLessonsMessages } from "../lessons/stores/use-lessons-message"

export function LeftActivityAlertDialog() {
  const { isOpen, onClose, clearState, redirectUrl } = useLeftActivityAlertStore()
  const { clearState: clearLessonsMessagesState } = useLessonsMessages()

  const navigate = useNavigate()

  const handleContinue = () => {
    onClose()
  }

  const handleLeave = () => {
    clearLessonsMessagesState()
    navigate(redirectUrl)
    clearState()
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose()
    }
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent className="max-w-md">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-yellow-50">
          <AlertTriangle className="h-10 w-10 text-yellow-400" />
        </div>
        <AlertDialogHeader className="mt-2 text-center">
          <AlertDialogTitle className="text-center text-lg font-bold leading-[120%]">
            ¿Seguro que querés salir de la actividad?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center text-sm leading-[143%] text-muted-foreground">
            Si salís ahora, vas a perder todo tu progreso.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-col gap-y-2 sm:gap-y-4 lg:flex-col">
          <AlertDialogAction asChild onClick={handleContinue}>
            <Button type="button" className="w-full">
              Continuar estudiando
            </Button>
          </AlertDialogAction>
          <AlertDialogCancel asChild onClick={handleLeave} className="w-full">
            <Button type="button" variant="outline" className="w-full">
              Abandonar actividad
            </Button>
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
